import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import axios from "axios";
import { baseurl } from "../Baseurl"; // example: https://backend.techsparesindia.com

const PaymentGateway = () => {
  const location = useLocation();
  const formRef = useRef();
  const [payuData, setPayuData] = useState(null);
  const [loading, setLoading] = useState(true);

  const stateData = location.state;

  useEffect(() => {
    if (!stateData) return;

    const processPayment = async () => {
      try {
        console.log("stateData", stateData);
        const response = await axios.post(`${baseurl}initiatePayment`, stateData);

        console.log("response", response);

        if (response.data?.success && response.data?.payuData) {
          setPayuData(response.data.payuData);
          setLoading(false);

          // ✅ Auto-submit the PayU form after a small delay
          setTimeout(() => {
            if (formRef.current) {
              formRef.current.submit();
            }
          }, 100);
        } else {
          console.error("Error in backend response:", response.data?.message);
          setLoading(false);
        }
      } catch (err) {
        console.error("Error initiating payment:", err);
        setLoading(false);
      }
    };

    processPayment();
  }, [stateData]);

  return (
    <>
      <VisitorNavbar />
      <div className="container py-3">
        <h4 className="hesd mb-4 text-start">Payment Gateway</h4>
        <div className="row">
          <div className="col-md-6 offset-md-3">
            {loading ? (
              <div className="text-center">Processing payment request...</div>
            ) : payuData ? (
              <form
                ref={formRef}
                method="post"
                action="https://secure.payu.in/_payment"
              >
                {Object.entries(payuData).map(([key, value]) => (
                  <input key={key} type="hidden" name={key} value={value} />
                ))}

                <button type="submit" className="btn btn-success w-100">
                  Pay ₹{payuData.amount} via PayU
                </button>
              </form>
            ) : (
              <div className="text-danger text-center">Something went wrong.</div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentGateway;
